export enum BFXAppNotificationEventType {
  ORDER_UPDATE_EVENT,
  DEAL_UPDATE_EVENT,
}
